import { J as r, $ as n } from "./Promise.bs-06a7bae6.mjs";

import { r as t, c as e } from "./belt_Array-b9ebcaa6.mjs";

import { b as u, g as o, i as f, c as i, d as a, m as c, a as s, f as l } from "./belt_Result-a4eb468a.mjs";

import { s as _ } from "./caml_option-16487d6d.mjs";

import { c as m } from "./caml_exceptions-99f2c2ac.mjs";

import { i as p } from "./caml_js_exceptions-5c6894a5.mjs";

var h = m("Result.ResultError");

function mapException(n) {
  if (n.RE_EXN_ID === r) {
    return {
      TAG: 1,
      _0: n._1
    };
  } else {
    return {
      TAG: 1,
      _0: n
    };
  }
}

function makeOk(r) {
  return {
    TAG: 0,
    _0: r
  };
}

function makeError(r) {
  return {
    TAG: 1,
    _0: r
  };
}

function _fromNullable(r, n) {
  if (null == r) {
    return {
      TAG: 1,
      _0: n
    };
  } else {
    return {
      TAG: 0,
      _0: r
    };
  }
}

function fromNullable() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _fromNullable(n, r[0]);
    };
  }
  return _fromNullable(arguments[0], arguments[1]);
}

function _fromFalsy(r, n) {
  if (r) {
    return {
      TAG: 0,
      _0: r
    };
  } else {
    return {
      TAG: 1,
      _0: n
    };
  }
}

function fromFalsy() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _fromFalsy(n, r[0]);
    };
  }
  return _fromFalsy(arguments[0], arguments[1]);
}

function _fromPredicate(r, n, t) {
  return a(fromNullable(r, t), (function(r) {
    if (n(r)) {
      return {
        TAG: 0,
        _0: r
      };
    } else {
      return {
        TAG: 1,
        _0: t
      };
    }
  }));
}

function fromPredicate() {
  if (2 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _fromPredicate(n, r[0], r[1]);
    };
  }
  return _fromPredicate(arguments[0], arguments[1], arguments[2]);
}

function fromExecution(r) {
  try {
    return {
      TAG: 0,
      _0: r(void 0)
    };
  } catch (r) {
    var n = p(r);
    if ("JsError" === n.RE_EXN_ID) {
      return {
        TAG: 1,
        _0: n._1
      };
    }
    throw n;
  }
}

function fromPromise(r) {
  return n(r.then((function(r) {
    return {
      TAG: 0,
      _0: r
    };
  })), (function(r) {
    return Promise.resolve(mapException(r));
  }));
}

var E = c;

function map() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return E(n, r[0]);
    };
  }
  return E(arguments[0], arguments[1]);
}

var A = s;

function mapWithDefault() {
  if (2 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return A(n, r[0], r[1]);
    };
  }
  return A(arguments[0], arguments[1], arguments[2]);
}

var G = l;

function flatMap() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return G(n, r[0]);
    };
  }
  return G(arguments[0], arguments[1]);
}

var T = u;

var d = o;

function getWithDefault() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return d(n, r[0]);
    };
  }
  return d(arguments[0], arguments[1]);
}

function toUndefined(r) {
  return o(r, void 0);
}

function toNullable(r) {
  return o(r, null);
}

function toOption(r) {
  if (0 === r.TAG) {
    return _(r._0);
  }
}

function _match(r, n, t) {
  if (0 === r.TAG) {
    return n(r._0);
  } else {
    return t(r._0);
  }
}

function match() {
  if (2 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _match(n, r[0], r[1]);
    };
  }
  return _match(arguments[0], arguments[1], arguments[2]);
}

var g = f;

var v = i;

function _tap(r, n) {
  if (0 !== r.TAG) {
    return r;
  }
  n(r._0);
  return r;
}

function tap() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _tap(n, r[0]);
    };
  }
  return _tap(arguments[0], arguments[1]);
}

function _tapError(r, n) {
  if (0 === r.TAG) {
    return r;
  }
  n(r._0);
  return r;
}

function tapError() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _tapError(n, r[0]);
    };
  }
  return _tapError(arguments[0], arguments[1]);
}

function _handleError(r, n) {
  if (0 === r.TAG) {
    return r;
  } else {
    return {
      TAG: 0,
      _0: n(r._0)
    };
  }
}

function handleError() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _handleError(n, r[0]);
    };
  }
  return _handleError(arguments[0], arguments[1]);
}

function _mapError(r, n) {
  if (0 === r.TAG) {
    return r;
  } else {
    return {
      TAG: 1,
      _0: n(r._0)
    };
  }
}

function mapError() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _mapError(n, r[0]);
    };
  }
  return _mapError(arguments[0], arguments[1]);
}

function _catchError(r, n) {
  if (0 === r.TAG) {
    return r;
  } else {
    return n(r._0);
  }
}

function catchError() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _catchError(n, r[0]);
    };
  }
  return _catchError(arguments[0], arguments[1]);
}

function _recover(r, n) {
  return catchError(r, (function(r) {
    return {
      TAG: 0,
      _0: n
    };
  }));
}

function recover() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _recover(n, r[0]);
    };
  }
  return _recover(arguments[0], arguments[1]);
}

function flip(r) {
  if (0 === r.TAG) {
    return {
      TAG: 1,
      _0: r._0
    };
  } else {
    return {
      TAG: 0,
      _0: r._0
    };
  }
}

function _filter(r, n) {
  return l(r, (function(r) {
    if (n(r)) {
      return {
        TAG: 0,
        _0: r
      };
    } else {
      return {
        TAG: 1,
        _0: {
          RE_EXN_ID: h,
          message: "[Result.filter]: not found"
        }
      };
    }
  }));
}

function filter() {
  if (1 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _filter(n, r[0]);
    };
  }
  return _filter(arguments[0], arguments[1]);
}

function _fold(r, n, t) {
  if (0 === r.TAG) {
    return n(r._0);
  } else {
    return t(r._0);
  }
}

function fold() {
  if (2 === arguments.length) {
    const r = arguments;
    return function fn(n) {
      return _fold(n, r[0], r[1]);
    };
  }
  return _fold(arguments[0], arguments[1], arguments[2]);
}

function all(r) {
  return t(r, {
    TAG: 0,
    _0: []
  }, (function(r, n) {
    return l(r, (function(r) {
      if (0 === n.TAG) {
        return {
          TAG: 0,
          _0: e(r, [ n._0 ])
        };
      } else {
        return {
          TAG: 1,
          _0: {
            RE_EXN_ID: h,
            message: "[Result.all]: found Error data type"
          }
        };
      }
    }));
  }));
}

export { filter as A, fold as B, all as C, h as R, makeOk as a, makeError as b, fromFalsy as c, fromPredicate as d, fromExecution as e, fromNullable as f, fromPromise as g, map as h, mapWithDefault as i, flatMap as j, T as k, getWithDefault as l, mapException as m, toNullable as n, toOption as o, match as p, g as q, v as r, tap as s, toUndefined as t, tapError as u, handleError as v, mapError as w, catchError as x, recover as y, flip as z };
